
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppNavbar from './Components/Navbar/Navbar';
import HomeScreen from './Components/Home/Home';
import Membership from './Components/Membership/Membership';
import TypesOfMembers from './Components/Membership/TypesOfMembers';
import Footer from './Components/Footer/Footer';
import StartAnewClub from './Components/Membership/StartAnewClub';
import StartaLeoClub from './Components/Membership/StartaLeoClub';
import TypesofClub from './Components/Membership/TypesofClub';
import MembershipGrant from './Components/Membership/MembershipGrant';
import NewMembershipForm from './Components/Membership/NewMembershipForm';
import MemberInductionCeremony from './Components/Membership/MemberInductionCeremony';
import MemberOrientation from './Components/Membership/MemberOrientation';
import MyLciLogintocheckdues from './Components/Membership/MyLciLogintocheckdues';
import PayMembershipDues from './Components/Membership/PayMembershipDues';
import MembershipAwards from './Components/Membership/MembershipAwards';
import LeoAwards from './Components/Membership/LeoAwards';
import MembershipHighlights from './Components/Membership/MembershipHighlights';
import ContentPage from './Components/Membership/LeoAwards';
import Login from './Components/Auth/Login';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import AdminPage from './Components/Admin/AdminPage';

import LeadersPage from './Components/Directory/Directory';

import InternationalLeaders from './Components/Directory/InternationalLeaders';
import Indiadirectory from './Components/Directory/Indiadirectory';
import AdminLoginPage from './Components/Admin/AdminLogin';
import AdminProtectedRoute from './Components/ProtectedRoute/AdminProtectedRoute';
import FlipBook from './Components/Magzines.js/FlipBook';
import ProfileForm from './Components/ProfileForm/ProfileForm';
import Isame2025 from './Components/Isame/Isame2025';
import WeeksofService from './Components/WeeksofService/WeeksofService';
import MHWPage from './Components/WeeksofService/MHWPage';
import Awards from './Components/WeeksofService/Awards';
import Blog from './Components/WeeksofService/Blog';
import HungerPage from './Components/WeeksofService/HungerPage';
import HungerAwards from './Components/WeeksofService/HungerAwards';
import HungerBlog from './Components/WeeksofService/HungerBlog';
import AllIndiaSchooling from './Components/AllIndiaSchooling/AllIndiaSchooling';
import EventSchedule from './Components/AllIndiaSchooling/EventSchedule';
import ServeIndia from './Components/Home/ServeIndia';
import Feedbackform from './Components/Feedbackform/Feedbackform';

const AppContent = ({ selectedLang, setSelectedLang }) => {
  const location = useLocation();
  // const location1 = useLocation();
  //const isLoginPage = location.pathname === '/login' && '/AdminPagelionsIndia';
  const isLoginPage =
    location.pathname === '/login' ||
    location.pathname === '/AdminPagelionsIndia' ||
    location.pathname === '/adminlogin' ||
    location.pathname === '/Leaders_Profile_Form';

  return (
    <div className="App">
      {/* {!isLoginPage && <AppNavbar />} */}
      {!isLoginPage && (
        <AppNavbar selectedLang={selectedLang} setSelectedLang={setSelectedLang} />
      )}

      <Routes>


        {/* <Route path="/" element={<HomeScreen />} /> */}
        <Route path="/" element={<HomeScreen selectedLang={selectedLang} />} />
        <Route path="/content" element={<ContentPage selectedLang={selectedLang} />} />


        {/* <Route
          path="/content"
          element={
            <ProtectedRoute>
              <ContentPage />
            </ProtectedRoute>
          }
        /> */}

        {/* ✅ Public Route */} -
        <Route path="/login" element={<Login />} />
        {/* <Route path="/AdminPagelionsIndia" element={<AdminPage />} /> */}
        <Route path="/leadersPage" element={<LeadersPage />} />
        <Route path="/isame2025" element={<Isame2025 />} />
        <Route path="/WeeksofService" element={<WeeksofService />} />
        <Route path="/AllIndiaSchooling" element={<AllIndiaSchooling />} />
        <Route path="/EventSchedule" element={<EventSchedule />} />
        <Route path="/mhw" element={<MHWPage />} />
        <Route path="/awards" element={<Awards />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/hunger" element={<HungerPage />} />
        <Route path="/hunger-awards" element={<HungerAwards />} />
        <Route path="/hunger-blog" element={<HungerBlog />} />

        <Route path="/serve-india" element={<ServeIndia />} />
        <Route path="/feedbackform" element={<Feedbackform />} />

        {/* <Route path="/internationalLeaders" element={<InternationalLeaders />} />
        <Route path="/indiadirectory" element={<Indiadirectory />} /> */}
        <Route path="/Flipbook" element={<FlipBook />} />

        <Route path="/internationalLeaders" element={<ProtectedRoute><InternationalLeaders selectedLang={selectedLang} /></ProtectedRoute>} />
        <Route path="/indiadirectory" element={<ProtectedRoute><Indiadirectory selectedLang={selectedLang} /></ProtectedRoute>} />
        <Route path="/adminlogin" element={<AdminLoginPage />} />
        <Route path="/AdminPagelionsIndia" element={<AdminProtectedRoute><AdminPage /></AdminProtectedRoute>} />
        <Route path="/Leaders_Profile_Form" element={<ProfileForm />} />
      </Routes>

      {!isLoginPage && <Footer selectedLang={selectedLang} />}
    </div>
  );
};

function App() {
  // ✅ central language state here
  const [selectedLang, setSelectedLang] = useState('English');

  return (
    <Router>
      {/* <AppContent /> */}
      <AppContent selectedLang={selectedLang} setSelectedLang={setSelectedLang} />
    </Router>
  );
}

export default App;
